import Exception from "src/utils/exception";
import Constants from "src/utils/constants";
import DBOperationsComb from "src/utils/dbOperationsComb";

const tableName = Constants.enums.TABLES_NAME_ENUM.BLADES_TYPES_TABLE;

async function fetchBladeTypes(config, offlineFirst = false) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName,
        ...config
      },
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function fetchBladeType(bladeTypeId, offlineFirst = false) {
  try {
    return await DBOperationsComb.getData(tableName, bladeTypeId, offlineFirst);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function createBladeType(data, offlineFirst = false) {
  try {
    return await DBOperationsComb.insertData(tableName, data, offlineFirst);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function updateBladeType(bladeTypeId, data, offlineFirst = false) {
  try {
    const updatedData = { ...data, id: data?.id ?? bladeTypeId };
    return await DBOperationsComb.updateData(
      tableName,
      updatedData,
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function deleteBladeType(bladeTypeId, offlineFirst = false) {
  try {
    let data = {
      id: bladeTypeId,
      is_deleted: true
    };
    return await DBOperationsComb.updateData(tableName, data, offlineFirst);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function reactivateBladeType(bladeTypeId, offlineFirst) {
  try {
    let data = {
      id: bladeTypeId,
      is_deleted: false
    };

    return await DBOperationsComb.updateData(tableName, data, offlineFirst);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  fetchBladeTypes,
  fetchBladeType,
  createBladeType,
  updateBladeType,
  deleteBladeType,
  reactivateBladeType
};
